import './term.css';

import { WarningIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  VStack
} from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { acceptionConsent } from '../../services/previdencia-individual/consentimento.service';
import { TermConclusion } from './TermConclusion';

const text = `Por meio deste Termo, a Sul América (“Controladora de dados pessoais”) fica autorizada a compartilhar os dados pessoais do Titular e dados relativos ao(s) plano(s) de previdência complementar mantido(s) pelo Titular junto à seguradora com o(s) corretor(es) de seguros devidamente identificado(s) (“Corretor”) e que foi/foram previamente apontado(s) como responsável(is) pelo(s) plano(s), caso seja necessário para as seguintes finalidades listadas abaixo, observados os princípios e as garantias estabelecidas pela Lei nº 13.709/18:

Efetuar acompanhamento do(s) saldo(s) do(s) planos e realizar atividades consultivas junto ao Titular de dados; 
Operacionalizar pedidos de resgate e portabilidade para o Titular de dados;
Na hipótese de o Titular de dados ter contratado Plano de Cobertura de Risco, acompanhar o Plano, dando consultoria para o Titular de dados e acompanhar a regulação de sinistros para o titular de dados, inclusive tendo acesso a dados de saúde do segurado, quando necessário
O Titular fica ciente que os seguintes dados serão compartilhados com o Corretor:
Dados financeiros, Dados Tributários, Dados de Sinistro e Dados de Saúde (quando necessário).

O Titular poderá exercer os direitos previstos na Lei nº 13.709/18, incluindo a revogação deste consentimento, a qualquer momento, mediante solicitação registrada junto ao Controlador no Portal de Privacidade da Sul América [ https://portal.sulamericaseguros.com.br/privacidade/ ].  
Na hipótese de alteração do Corretor, o Titular desde já fica ciente de que deverá o canal acima descrito para cancelar este consentimento de compartilhamento de dados pessoais. Ao nomear novo Corretor, deverá realizar novamente o processo de autorização de compartilhamento.

O Titular fica desde já ciente de que este consentimento terá validade enquanto for Participante do(s) Plano(s) de Previdência Complementar da Sul América, exceto se realizar a revogação do consentimento. Após esse período, os Dados serão, a critério da SulAmérica, anonimizados para uso exclusivo da SulAmérica ou excluídos, salvo se a manutenção dos Dados for exigida e/ou permitida por lei. 
O não exercício pela SulAmérica ou pelo Titular de quaisquer direitos ou faculdades que lhes sejam conferidos por este Termo ou pela legislação brasileira, não importará na renúncia aos seus direitos ou alteração de itens e cláusulas deste Termo, podendo a SulAmérica ou o Titular exercê-los a qualquer momento.
A aceitação livre e expressa deste Termo (seja por meio de voz, aceite em canal de comunicação ou marcação de check box em área logada) será considerada, para todos os fins de direito, como concordância e aceitação de todos os termos e condições do presente Termo e consentimento para o tratamento dos dados.
`;

export const Term = (): JSX.Element => {
  const [clickedSubmitButton, setCLickedSubmitButton] = useState(false);
  const [acceptedTerm, setAcceptedTerm] = useState(false);
  const { isOpen, onOpen: openErrorModal, onClose } = useDisclosure();
  const navigate = useNavigate();

  const windowWidth = window.innerWidth;
  const bffUrl = process.env.REACT_APP_API_URL;

  // const url = 'http://localhost:5000/v1/consentimentos'
  const url = `${bffUrl}/consentimentos/term`;

  const { isLoading, mutate } = useMutation({
    mutationFn: (accepted: boolean) => acceptionConsent(accepted),
    onSuccess: (res) => {
      setCLickedSubmitButton(true);
      console.log('success:', res);
    },
    onError: (err) => {
      openErrorModal();
      console.log('error:', err);
    }
  });

  const searchParams = window.location.search;
  const token = searchParams.split('=')[1];

  const handleSubmit = async (acceptedTerms: boolean) => {
    //chama api
    mutate(acceptedTerms);
    setAcceptedTerm(acceptedTerms);
    // }
  };

  const postConsentimento = async (acceptedTerm: boolean) => {
    /* const headers = {
      // cpf: token,
      token: token
      // codigo_produtor: 123
    };
    const decodedToken = atob(token);
    const cpf = decodedToken.split(':')[0];
    const codigoProdutor = decodedToken.split(':')[1];

    const today = new Date();
    const data = {
      cpf: cpf,
      codigoProdutor: codigoProdutor,
      dataAlteracao: String(today.toLocaleDateString()),
      consentimento: acceptedTerm,
      nome: 'Fabio M Colavite'
    };
    axios({
      method: 'POST',
      url: `${url}`,
      data: data,
      headers
    })
      .then((response) => {
        if (response.data?.cpf == data.cpf) setCLickedSubmitButton(true);
        else onOpen();
      })
      .catch((error) => {
        onOpen();
      }); */
  };

  function ErrorModal() {
    return (
      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent padding={'15px'} width="auto">
            <ModalHeader alignSelf={'center'} fontSize={'19px'} color="red.500">
              <WarningIcon
                style={{ marginRight: '10px' }}
                w={8}
                h={8}
                color="red.500"
              />{' '}
              Erro
            </ModalHeader>
            <ModalBody alignSelf={'center'} fontSize={'18px'}>
              Erro ao se conectar com o servidor
            </ModalBody>
            <ModalFooter>
              <Button
                borderRadius="133.5px"
                borderColor={'black'}
                border={'1px solid #000000'}
                width="100%"
                background="#FFFFFF"
                onClick={onClose}
              >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  return clickedSubmitButton ? (
    <TermConclusion approved={acceptedTerm} />
  ) : (
    <>
      <Box
        w="100%"
        p={['30px 16px', '30px 16px', '30px 50px']}
        bg="#F5F5F5"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <ErrorModal />
        <VStack
          w="100%"
          m="15px !important"
          bg="#FFFFFF"
          boxShadow="0px 0px 9px 5px #0000000a"
          borderRadius="12px"
          alignItems={'left'}
        >
          <p
            style={{
              fontSize: '18px',
              padding: '22px 25px 10px 30px',
              textAlign: 'justify',
              fontWeight: 'bold',
              display: 'inline',
              textOverflow: 'ellipsis',
              wordWrap: 'break-word'
            }}
          >
            Consentimento Previdência individual
          </p>
          <hr></hr>
          <div
            style={{
              padding: '20px 10px 30px 0px'
            }}
          >
            <p
              style={{
                maxHeight: '320px',
                padding: '0px 25px 0px 30px',
                overflow: 'overlay',
                whiteSpace: 'break-spaces',
                textAlign: 'justify',
                wordWrap: 'break-word',
                overflowX: 'hidden',
                WebkitOverflowScrolling: 'initial'
              }}
            >
              {text}
            </p>
          </div>
        </VStack>
        <p
          style={{
            padding: '10px 0px 10px 0px',
            fontSize: '18px',
            fontWeight: 'bold'
          }}
        >
          Você está de acordo com os termos previstos?
        </p>
        <div
          style={{
            width: windowWidth > 700 ? '' : '100%',
            paddingTop: '10px'
          }}
        >
          <Button
            justifyContent="center"
            w={['100%', '100%', '180px']}
            bg={`#FF5000`}
            m="0 !important"
            h="40px"
            p="13px 47px"
            gap="10px"
            borderRadius="133.5px"
            color="#FFFFFF"
            fontWeight="700"
            fontSize="1rem"
            lineHeight="1.375rem"
            textAlign="center"
            alignSelf={'right'}
            onClick={() => {
              handleSubmit(true);
            }}
            _hover={{
              WebkitFilter: ' brightness(60%)',
              transition: 'all 0.4s',
              WebkitTransition: 'all 0.4s'
            }}
            _focus={{
              '&:focus': {
                boxShadow: 'none !important'
              }
            }}
          >
            {'Sim'}
          </Button>
          <Button
            justifyContent="center"
            w={['100%', '100%', '180px']}
            bg={`#FFFFFF`}
            marginLeft={windowWidth > 700 ? '20px' : '0'}
            marginTop={windowWidth < 700 ? '10px' : '0'}
            h="40px"
            p="13px 47px"
            gap="10px"
            borderRadius="133.5px"
            borderWidth={'medium'}
            color="black"
            fontWeight="700"
            fontSize="1rem"
            lineHeight="1.375rem"
            textAlign="center"
            alignSelf={'right'}
            onClick={() => {
              handleSubmit(false);
            }}
            _hover={{
              WebkitFilter: ' brightness(60%)',
              transition: 'all 0.4s',
              WebkitTransition: 'all 0.4s'
            }}
            _focus={{
              '&:focus': {
                boxShadow: 'none !important'
              }
            }}
          >
            {'Não'}
          </Button>
        </div>
      </Box>
    </>
  );
};
